import { useTranslation } from 'react-i18next'
import { Navigate, Outlet } from 'react-router'
import { ErrorState } from '@/components/ui/ErrorState'
import { Spinner } from '@/components/ui/Spinner'
import { usePartnerProfile } from '@/features/auth/api'
import { useAuth } from '@/features/auth/auth-context'

function FullPage({ children }: { children: React.ReactNode }) {
  return <div className="flex min-h-dvh items-center justify-center p-6">{children}</div>
}

export function RequireSession() {
  const { t } = useTranslation()
  const { phase } = useAuth()

  if (phase === 'restoring') {
    return (
      <FullPage>
        <Spinner label={t('common.loading')} />
      </FullPage>
    )
  }

  if (phase === 'anonymous') {
    return <Navigate to="/login" replace />
  }

  return <Outlet />
}

export function RequireApproved() {
  const { t } = useTranslation()
  const profile = usePartnerProfile()

  if (profile.isPending) {
    return <Spinner label={t('common.loading')} />
  }

  if (profile.isError) {
    return <ErrorState error={profile.error} onRetry={() => void profile.refetch()} />
  }

  if (profile.data.status !== 'APPROVED') {
    return <Navigate to="/pending" replace />
  }

  return <Outlet />
}

export function RedirectWhenSignedIn() {
  const { phase } = useAuth()

  if (phase === 'authenticated') {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
